
import { ApiService } from "./api-service/api-service";
import { ImgService } from "./api-service/img-service";
import { NativeService } from "./api-service/native-service";
import { NoticeService } from "./api-service/notice-service";
import { NetworkService } from "./api-service/network-service";
import { CartService } from "./data-service/cart-service";
import { CategoryService } from "./data-service/category-service";
import { OrderService } from "./data-service/order-service";
import { SaleService } from "./data-service/sale-service";
import { UserService } from "./data-service/user-service";
import { LotteryService } from "./data-service/lottery-service"
import { MoveshopService } from "./data-service/moveshop-service"
import { SocialService } from "./data-service/social-service";
import { ArticleService} from "./data-service/article-service";
import { ImageService } from "./api-service/image-service";
import { CropService} from "./api-service/crop-service";

export {
  ApiService, ImgService, NativeService, NoticeService, NetworkService, SocialService,ImageService,CropService,
  CartService, CategoryService, OrderService, SaleService, UserService, LotteryService,MoveshopService,ArticleService,

};



// WEBPACK FOOTER //
// ./src/providers/providers.ts